import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';


@Component({
  selector: 'primeng-checkboxlabel-wrapper',
  imports:[],
  template: `
    <div class="mb-2">
        <ng-container #fieldComponent></ng-container>
    </div>
  `,
})
export class PrimeNGCheckboxWrapper extends FieldWrapper {
}